import Dashboard from "layouts/Dashboard/Dashboard.jsx";
import CustomerInfo from "../views/Customers/CustomerInfo.jsx";
var indexRoutes = [
    { path: "/", name: "Home", component: Dashboard },
    { path: "/customerinfo2", name: "CustomerInfo", component: CustomerInfo }
];

export default indexRoutes;
